import logger from '@eb/client-logger';
import loadable from '@loadable/component';
import RawHTMLModule from './RawHtml';

const EmptyModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'EmptyModule' */ '../sharedComponents/EmptyModule'
        ),
);
const CallToActionModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'CallToActionModule' */ './call-to-action/CallToAction'
        ),
);
const CallToActionHeroModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'CallToActionHeroModule' */ './call-to-action-hero/CallToActionHero'
        ),
);
const DividerModule = loadable(
    () => import(/* webpackChunkName: 'DividerModule' */ './divider/Divider'),
);
const FAQModule = loadable(
    () => import(/* webpackChunkName: 'FAQModule' */ './faq/Faq'),
);
const FeatureModule = loadable(
    () => import(/* webpackChunkName: 'FeatureModule' */ './feature/Feature'),
);
const ImageResourceCardsModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'ImageResourceCardsModule' */ './image-resource-card/ImageResourceCards'
        ),
);
const PayoutModule = loadable(
    () => import(/* webpackChunkName: 'PayoutModule' */ './payout/Payout'),
);
const PricingModule = loadable(
    () => import(/* webpackChunkName: 'PricingModule' */ './pricing/Pricing'),
);
const PricingCalculatorModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'PricingCalculatorModule' */ './pricing-calculator/PricingCalculator'
        ),
);
const ProductHighlightModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'ProductHighlightModule' */ './product-highlight/ProductHighlight'
        ),
);
const ResourceCardsModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'ResourceCardsModule' */ './resource-cards/ResourceCards'
        ),
);
const RichTextModule = loadable(
    () =>
        import(/* webpackChunkName: 'RichTextModule' */ './rich-text/RichText'),
);
const TestimonialsModule = loadable(
    () =>
        import(
            /* webpackChunkName: 'TestimonialsModule' */ './testimonial/Testimonial'
        ),
);
const VideoModule = loadable(
    () => import(/* webpackChunkName: 'VideoModule' */ './video/Video'),
);

interface ModuleDictionary {
    faq_content: any;
    image_resource_cards_content: any;
    raw_html_content: any;
    payout_content: any;
    product_highlight_content: any;
    testimonials_content: any;
    resource_cards_content: any;
    feature_content: any;
    divider_content: any;
    call_to_action_content: any;
    video_content: any;
    call_to_action_hero_content: any;
    rich_text_content: any;
    pricing_content: any;
    pricing_calculator_content: any;
}

const MODULE_TYPE_TO_COMPONENT: ModuleDictionary = {
    call_to_action_content: CallToActionModule,
    divider_content: DividerModule,
    faq_content: FAQModule,
    feature_content: FeatureModule,
    image_resource_cards_content: ImageResourceCardsModule,
    pricing_content: PricingModule,
    raw_html_content: RawHTMLModule,
    payout_content: PayoutModule,
    product_highlight_content: ProductHighlightModule,
    resource_cards_content: ResourceCardsModule,
    testimonials_content: TestimonialsModule,
    video_content: VideoModule,
    call_to_action_hero_content: CallToActionHeroModule,
    rich_text_content: RichTextModule,
    pricing_calculator_content: PricingCalculatorModule,
};

export const getModuleComponent = (type: string) => {
    if (!MODULE_TYPE_TO_COMPONENT.hasOwnProperty(type)) {
        logger.warn('Unknown Wagtail module type.', { type });
        return EmptyModule;
    }

    return MODULE_TYPE_TO_COMPONENT[type as keyof ModuleDictionary];
};
